import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link, Outlet } from 'react-router-dom'
import { useAuth } from './useAuth'

interface RequirePermissionProps {
  /** Kamida bittasi bo'lsa sahifa ochiladi */
  permission: string | readonly string[]
}

/**
 * Marshrut darajasidagi huquq qo'riqchisi.
 *
 * Navigatsiya baribir ko'rinmaydigan sahifaga havola chizmaydi, lekin
 * URL qo'lda kiritilishi yoki eski havola saqlangan bo'lishi mumkin.
 * U holda "Ruxsat yo'q" ko'rsatiladi — bo'sh sahifa yoki tushunarsiz
 * xato emas.
 *
 * ⚠️ Yana bir bor: bu QULAYLIK. Ma'lumot baribir backend tekshiruvidan
 * o'tmasdan kelmaydi (04-ROLES.md §8).
 */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const { t } = useTranslation()
  const { can } = useAuth()
  const list = typeof permission === 'string' ? [permission] : permission

  if (!list.some(can)) {
    return (
      <Result
        status="403"
        title={t('access.deniedTitle')}
        subTitle={t('access.deniedText')}
        extra={
          <Link to="/">
            <Button type="primary">{t('access.backToStart')}</Button>
          </Link>
        }
      />
    )
  }

  return <Outlet />
}
